import React from "react";
import {
  HomeSpan,
  HomeBalanceContainer,
  HomeBox,
  HomeBoxWrapper,
  HomeBoxImg,
  HomeP01,
  SmallZero,
  HomeAmount,
  HomeBoxContainer,
} from "./homeBalance.styles";

import { IoWalletOutline } from "react-icons/io5";
import { HomeBoxGreen, HomeBoxPurple } from "../../../../../public/assets";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { getUserBankDetails } from "../../../../graphql/queries/accounts";
import { LoadingSpinner, Overlay } from "../../../../pages/AddUserPage/AddUser";

const Index = () => {
  const navigate = useNavigate();

  const navigateToAccounts = () => {
    navigate("/dashboard/accounts");
  };

  const { data: queryData, refetch: refetchUserBankDetails } =
    useQuery(getUserBankDetails);

  const userBankDetails = queryData?.getUserBankDetails || {};
  const amount = userBankDetails?.userFinancialDetails?.available;
  const [mainAmount, smallZero] = amount?.toFixed(2)?.split(".") || "0";
  const checkerArr = Object.keys(userBankDetails);
  const data = [
    {
      imgSrc: "/assets/svg/HomeBoxGreen.svg",
      altText: "",
      title: "Account Balance",
      amount: `$${mainAmount}`,
      fraction: smallZero,
      backgroundColor: "#CCF4CD99",
      link: navigateToAccounts,
    },
    {
      imgSrc: "/assets/svg/HomeBoxPurple.svg",
      altText: "",
      title: "Total Payout",
      amount: "$0",
      backgroundColor: "#CECCDE99",
    },
    {
      imgSrc: "/assets/svg/HomeBoxGreen.svg",
      altText: "",
      title: "Total Inflow",
      amount: "$0",
      backgroundColor: "#CCF4CD99",
    },
    {
      imgSrc: "/assets/svg/HomeBoxPurple.svg",
      altText: "",
      title: "Total No of Transactions",
      amount: "0",
      backgroundColor: "#CECCDE99",
    },
  ];

  return (
    <HomeBalanceContainer>
      {checkerArr.length === 0 ? (
        <span>Data loading...</span>
      ) : (
        <>
          <HomeSpan>Balances</HomeSpan>
          <HomeBoxContainer>
            {data.map((item, index) => (
              <HomeBox key={index} onClick={item.link}>
                <HomeBoxImg style={{ backgroundColor: item.backgroundColor }}>
                  <IoWalletOutline style={{ fontSize: "25px" }} />
                </HomeBoxImg>
                <HomeBoxWrapper>
                  <HomeP01>{item.title}</HomeP01>
                  <HomeAmount>
                    {item.amount}.<SmallZero>{item.fraction || "00"}</SmallZero>{" "}
                  </HomeAmount>
                </HomeBoxWrapper>
              </HomeBox>
            ))}
          </HomeBoxContainer>
        </>
      )}
    </HomeBalanceContainer>
  );
};

export default Index;
